import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { first } from 'rxjs/operators';
import { LookupService } from 'src/app/services/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { LprDataService } from 'src/app/services/lpr-data.service';
@Component({
  selector: 'app-search-lpr-violation-dialog',
  templateUrl: './search-lpr-violation-dialog.component.html',
  styleUrls: ['./search-lpr-violation-dialog.component.scss']
})
export class SearchLprViolationDialogComponent implements OnInit {
  public pastActionObject: any = null;
  public imageDataLink: any = null;
  public matchedListType: any = "";
  public paymentDetails: any;
  public vehicleColor: any = "#FF0000";
  
  constructor(public dialog: MatDialogRef<SearchLprViolationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public lookupService: LookupService,
    public lprDataService: LprDataService,
    public toastrService: ToastrService) {
    this.init(data);
  }

  ngOnInit(): void {
  }

  init(data: any): void {

    if(data.paymentDetail){
      this.paymentDetails = JSON.parse(data.paymentDetail);
    }

    if(data.matchedStatus == "Unauthorized"){
      if(data.matchedListType == "Payment"){
        this.matchedListType = " - Payment found in a different zone";
      }
      else if(data.matchedListType == "Permit"){
        this.matchedListType = " - Permitted Plate found in a different zone";
      }
      else if(data.matchedListType == "NotPermit"){
        this.matchedListType = " - License Plate not found in Permitted List";
      }
      else if(data.matchedListType == "PermitGateway"){
        this.matchedListType = " - Permit found in a different zone";
      }
      else{
        this.matchedListType = "";
      }
    }

    this.pastActionObject = data;
    this.imageDataLink = this.pastActionObject.payloadId;
    
    let vehColor;
    if(this.pastActionObject.vehicleColor && this.pastActionObject.vehicleColor != "0"){
      vehColor = parseInt(this.pastActionObject.vehicleColor).toString(16);
    }
    else{
      vehColor = "26293B";      
    }
    this.vehicleColor = "#" + vehColor;

    this.lprDataService.searchLprViolationImageDetail(this.imageDataLink)
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          if (response.data !== null) {
            this.pastActionObject.image1 = (response.data.image1 === "") ? null : "data:image/jpeg;base64,"+ response.data.image1;
            this.pastActionObject.image2 = (response.data.image2 === "") ? null : "data:image/jpeg;base64,"+ response.data.image2;
          } else {
            this.pastActionObject.image1 = null;
            this.pastActionObject.image2 = null;
          }
        }
      });
  }
  closeDialog(): void {
    this.dialog.close();
  }
}
